import { render } from "./TransferQuotaToGroupPopup.vue?vue&type=template&id=5de99d78&scoped=true"
import script from "./TransferQuotaToGroupPopup.vue?vue&type=script&lang=js"
export * from "./TransferQuotaToGroupPopup.vue?vue&type=script&lang=js"

import "./TransferQuotaToGroupPopup.vue?vue&type=style&index=0&id=5de99d78&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de99d78"]])

export default __exports__